export class DropDownType {
  static TIGHTNESS = 1;
  static VENTILATION_METHOD = 2;
  static VENTILATION_FREQUENCY = 3;
  static WARM_WATER = 4;
}
